module.exports = __webpack_public_path__ + "static/media/innovation-illustration.e72a76b2.svg";